<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 content">
            <upsc-outage-banner *ngIf="isDynamicOutage" (closed)="onBannerClosed()" [message]="portalBanner?.messageText"></upsc-outage-banner>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<div class="footer">
    <upsc-footer></upsc-footer>
</div>